import { FlexBuyAvailableMonths as FlexBuyPayment } from '@makemydeal/dr-platform-types';

export const FlexBuyAvailableMonths = FlexBuyPayment;

export type PaymentPeriodFieldLabel = Record<`${FlexBuyPayment}_First` | `${FlexBuyPayment}_Next`, string>;

type ExtractPeriod<T> = T extends `${string}_${infer Period}` ? Period : never;

export type PaymentPeriodFieldType = ExtractPeriod<keyof PaymentPeriodFieldLabel>;

export type FlexBuyPercentOption = { id: string; label: string; value: string };
export type FlexBuyPercentOptions = Record<number, FlexBuyPercentOption[]>;

export type FlexBuyPaymentFigureField = { label: string; value: string };
